import React from 'react';
import { CERTIFICATES, FEEDBACK_IMAGES } from '../../constants/links';

function ProofWallSection() {
  return (
    <section 
      id="proof-wall" 
      className="relative z-10 min-h-screen py-16 md:py-24 px-3 md:px-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 text-xs font-inter tracking-[0.3em] uppercase text-[#00FF88] border border-[#00FF88]/30 rounded-full mb-4">
            Proof of Success
          </span>
          <h2 className="font-teko text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase text-[#F5F5F5] mb-4">
            <span className="text-[#00FF88]" style={{ textShadow: "0 0 15px rgba(0,255,136,0.4)" }}>WALL OF</span>{" "}
            PROOF
          </h2>
          <p className="text-sm md:text-base text-gray-400 font-inter max-w-2xl mx-auto">
            Real results, real certifications. Proven track record dari funded prop firms.
          </p>
        </div>

        {/* Funded Certificates Grid */}
        <div className="mb-16">
          <h3 className="font-teko text-2xl md:text-3xl font-bold uppercase text-[#F5F5F5] mb-6 text-center">
            Funded Certificates
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {CERTIFICATES.map((cert, index) => (
              <div
                key={cert.id}
                className="certificate-card group relative rounded-xl overflow-hidden border border-[#00FF88]/20 will-change-transform transition-all duration-500 hover:scale-105"
                style={{
                  background: "rgba(10,10,10,0.6)",
                  backdropFilter: "blur(20px)",
                  boxShadow: "0 0 20px rgba(0,255,136,0.1)"
                }}
              >
                {/* Certificate Image */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img 
                    src={cert.image} 
                    alt={cert.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  {/* Overlay Gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-60" />
                  
                  {/* Hover Glow Effect */}
                  <div 
                    className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: "radial-gradient(circle at center, rgba(0,255,136,0.2) 0%, transparent 70%)",
                      boxShadow: "inset 0 0 60px rgba(0,255,136,0.3)"
                    }}
                  />
                </div>

                {/* Certificate Info */}
                <div className="relative p-4">
                  <h4 className="font-teko text-lg md:text-xl font-bold uppercase text-[#F5F5F5] mb-1">
                    {cert.title}
                  </h4>
                  <p className="text-xs text-gray-400 font-inter mb-2">
                    {cert.subtitle}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] text-gray-500 font-mono">
                      {cert.date}
                    </span>
                    <div 
                      className="w-2 h-2 rounded-full bg-[#00FF88]"
                      style={{ boxShadow: "0 0 8px rgba(0,255,136,0.6)" }}
                    />
                  </div>
                </div>

                {/* LED Pulse Border (on hover) */}
                <div 
                  className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{
                    boxShadow: "0 0 30px rgba(0,255,136,0.4), 0 0 60px rgba(0,255,136,0.2), inset 0 0 30px rgba(0,255,136,0.1)"
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Community Feedback Marquee */}
        <div className="mt-16">
          <h3 className="font-teko text-2xl md:text-3xl font-bold uppercase text-[#F5F5F5] mb-6 text-center">
            Community Feedback
          </h3>
          <div className="relative overflow-hidden">
            {/* Gradient Masks */}
            <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
            
            {/* Marquee Container */}
            <div className="flex gap-4 animate-marquee">
              {/* Duplicate images for seamless loop */}
              {[...FEEDBACK_IMAGES, ...FEEDBACK_IMAGES, ...FEEDBACK_IMAGES].map((img, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-64 md:w-80 rounded-xl overflow-hidden border border-[#00FF88]/10"
                  style={{
                    background: "rgba(10,10,10,0.4)",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <img 
                    src={img} 
                    alt={`Feedback ${index + 1}`}
                    className="w-full h-auto object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Social Proof Stats */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-6 px-6 py-4 rounded-full border border-[#00FF88]/20" style={{ background: "rgba(0,255,136,0.02)" }}>
            <div>
              <div className="font-teko text-2xl md:text-3xl font-bold text-[#00FF88]">4,971+</div>
              <div className="text-xs text-gray-500 font-inter">Instagram Followers</div>
            </div>
            <div className="w-px h-8 bg-[#00FF88]/20" />
            <div>
              <div className="font-teko text-2xl md:text-3xl font-bold text-[#00FF88]">3+</div>
              <div className="text-xs text-gray-500 font-inter">Certifications</div>
            </div>
          </div>
        </div>
      </div>

      {/* CSS for Marquee Animation */}
      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}

export default ProofWallSection;
